import { GiftCardOrder } from 'api/types/giftCard/giftCard';

export const OUTER_CONTAINER_CLASSES = 'w-full max-w-full flex flex-none items-center px-4 md:px-10';
export const INNER_CONTAINER_CLASSES = 'flex flex-none w-full max-w-[1360px]';

export const HEADER_ROW_STYLES = 'flex pt-12 pb-3.5 px-10 gap-2 items-center';
export const HEADER_CELL_STYLES =
  'text-left font-semibold text-lg truncate break-all uppercase text-base font-klarheit font-semibold';
export const DATA_ROW_STYLES =
  'flex py-5 font-normal gap-2 items-center px-10 hover:cursor-pointer hover:bg-palette-secondary-light-grey';
export const DATA_CELL_STYLES = 'text-left text-sm truncate break-all tracking-tight';
export const FOOTER_ROW_STYLES = 'flex py-12 gap-2 justify-between px-10';

export const DEFAULT_EXPORT_ROW_NUM = 500;

export const SEARCH_DEBOUNCE_TIME = 800;

export const FILTER_KEYS = {
  pageNum: 'pageNum',
  pageSize: 'pageSize',
  status: 'status',
  createdDateFrom: 'createdDateFrom',
  createdDateTo: 'createdDateTo',
  senderShareId: 'senderShareId',
  recipientShareId: 'recipientShareId',
  orderId: 'orderId',
  mPayReference: 'mPayReference',
  productId: 'productId',
  premoId: 'premoId',
};

export const CARD_TYPES = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
};

export const USER_FILTERS = [
  { label: 'Order ID', id: FILTER_KEYS.orderId },
  { label: 'Sender SHARE ID', id: FILTER_KEYS.senderShareId },
  { label: 'Recipient SHARE ID', id: FILTER_KEYS.recipientShareId },
  { label: 'Premo ID', id: FILTER_KEYS.premoId },
  { label: 'MPAY Ref', id: FILTER_KEYS.mPayReference },
];

export const TABLE_COLUMN_MAP = [
  {
    headerLabel: 'Order Ref #',
    key: 'id',
  },
  {
    headerLabel: 'Sender SHARE ID',
    key: 'memberId',
  },
  {
    headerLabel: 'Recipient SHARE ID',
    key: 'recieverMemberId',
  },
  {
    headerLabel: 'Card Status',
    key: 'cardStatus',
  },
  {
    headerLabel: 'Card Type',
    key: 'cardType',
  },
  {
    headerLabel: 'Product Type',
    key: 'productType',
  },
  {
    headerLabel: 'Order Status',
    key: 'orderStatus',
  },
  {
    headerLabel: 'Created Date',
    key: 'created_at',
  },
];

export const DETAIL_GENERAL_INFO_MAP = [
  {
    headerLabel: 'ID',
    key: 'id',
  },
  {
    headerLabel: 'Premo ID',
    key: 'xid',
    test: (card: GiftCardOrder | undefined) => card?.cardType === CARD_TYPES.PHYSICAL,
  },
  {
    headerLabel: 'CARD ID',
    key: 'cardId',
  },
  {
    headerLabel: 'CREATED AT',
    key: 'created_at',
  },
  {
    headerLabel: 'UPDATED AT',
    key: 'updated_at',
  },
  {
    headerLabel: 'CARD STATUS',
    key: 'cardStatus',
  },
  {
    headerLabel: 'SENDER MEMBER ID',
    key: 'memberId',
  },
  {
    headerLabel: 'ORDER STATUS',
    key: 'orderStatus',
  },
  {
    headerLabel: 'PRODUCT ID',
    key: 'productId',
  },
  {
    headerLabel: 'CARD TYPE',
    key: 'cardType',
  },
  {
    headerLabel: 'NUMBER OF CARDS',
    key: 'numberOfCards',
  },
  {
    headerLabel: 'I2C REFERENCE ID',
    key: 'i2cReferenceId',
  },
  {
    headerLabel: 'RECIPIENT',
    key: 'reciever',
  },
];

export const DETAIL_RECIPIENT_INFO_MAP = [
  {
    headerLabel: 'RECIPIENT FIRST NAME',
    key: 'recieverFirstName',
  },
  {
    headerLabel: 'RECIPIENT LAST NAME',
    key: 'recieverLastName',
  },
  {
    headerLabel: 'RECIPIENT EMAIL',
    key: 'recieverEmail',
  },
  {
    headerLabel: 'RECIPIENT MOBILE',
    key: 'recieverMobile',
  },
  {
    headerLabel: 'RECIPIENT SHARE ID',
    key: 'recieverMemberId',
  },
];

export const DETAIL_PAYMENT_INFO_MAP = [
  {
    headerLabel: 'Payment method',
    key: 'paymentMethod',
  },
  {
    headerLabel: 'Payment status',
    key: 'cardPaymentStatus',
  },
  {
    headerLabel: 'points payment id',
    key: 'pointsPaymentId',
  },
  {
    headerLabel: 'points Amount',
    key: 'pointsAmount',
  },
  {
    headerLabel: 'Delivery method',
    key: 'deliveryMethod',
  },
  {
    headerLabel: 'Delivery fee',
    key: 'deliveryFee',
  },
  {
    headerLabel: 'Activation fee',
    key: 'activationFee',
  },
];
